import errors from './errors/index.js';
import translation from './translation/index.js';
const es = {
    translation,
    errors,
};
export default Object.freeze(es);
